import React, { Component } from 'react'
import PT from 'prop-types'
import { Link, withRouter } from 'react-router-dom'
import { Carousel } from 'element-react'
import Dots from 'react-carousel-dots'
import 'react-carousel-dots/src/index.css'
import { imagesProp } from '../../propTypes'
import { imagePrefix, imagePrefix89 } from '../Post/helpers'
import './Images.css'

// find shortest img from set and use that height
export const getShortest = (images) => {
  let shortestIndex = 0
  let shortestHeight = 9999
  images.forEach((img, index) => {
    if (img.height < shortestHeight) {
      shortestHeight = img.height
      shortestIndex = index
    }
  })
  return shortestIndex
}

class ImageSwiper extends Component {
  state = {
    activeIndex: 0,
  }

  handleChange = (activeIndex) => {
    this.setState({ activeIndex })
  }

  render() {
    const { images, to, location } = this.props
    const shortestIndex = getShortest(images)
    const { width, height } = images[shortestIndex]
    const h = height / (width / this.props.width)
    const is89 = location.pathname.startsWith('/89')
    const prefix = is89 ? imagePrefix89 : imagePrefix

    return (
      <Carousel
        height={`${h}px`}
        autoplay={false}
        trigger="click"
        arrow="always"
        className="image-swiper"
        onChange={this.handleChange}
      >
        {images.map(i => (
          <Carousel.Item key={i.thumbs[0].name}>
            <Link to={to}>
              <img src={prefix + i.thumbs[0].name} alt="" />
            </Link>
          </Carousel.Item>
        ))}
        <Dots
          length={images.length}
          active={this.state.activeIndex}
          height={14}
          margin={6}
        />
      </Carousel>
    )
  }
}

ImageSwiper.propTypes = {
  // eslint-disable-next-line
  images: imagesProp.isRequired,
  width: PT.number.isRequired,
  to: PT.string.isRequired,
  location: PT.shape({
    pathname: PT.string.isRequired,
  }).isRequired,
}

export default withRouter(ImageSwiper)



// WEBPACK FOOTER //
// ./src/components/Images/ImageSwiper.js